<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <!-- Escalate invoice/contract modals -->
        <InvoiceEscalateModals
            ref="InvoiceEscalateModals"
            :showEscalation="showEscalation"
            :showOutEscalation="showOutEscalation"
            @escalated="fetchRecord"
        />

        <!-- Force free modal -->
        <!-- <b-modal :active.sync="showForceFreeModal" class="invitemodal" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head"><p class="modal-card-title">Status forceren</p></header>
                <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                    <p>Weet je zeker dat je de status van de box op "Vrij" wil forceren?</p>
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-light" @click="showForceFreeModal = false">Annuleren</b-button>
                    <b-button type="is-primary" @click="forceFree" :loading="loading">Forceer status</b-button>
                </footer>
            </div>
        </b-modal> -->

        <div class="row">
            <div class="column medium-4 text-right float-right">
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button tag="router-link" :to="{ name: 'BoxesOverview' }" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-8">
                <h1>Box{{ record && typeof(record.number) != 'undefined' ? ' '+record.number : '' }}</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form">
                    <b-tabs size="is-medium" class="block" @input="tabChange" v-model="tabIndex">
                        <b-tab-item label="Algemeen">
                            <b-field label="Nummer / identificatie"
                                :message="getError(errors, 'number')"
                                :type="getType(errors, 'number', '')"
                            >
                                <b-input v-model="record.number"></b-input>
                            </b-field>

                            <div class="row">
                                <div class="column medium-3">
                                    <b-field label="Inhoud (m³)"
                                        :message="getError(errors, 'size')"
                                        :type="getType(errors, 'size', '')"
                                    >
                                        <b-input v-model="record.size"></b-input>
                                    </b-field>
                                </div>
                                <div class="column medium-9 paddingtop0">
                                    <div class="row">
                                        <div class="column medium-4">
                                            <b-field label="Lengte"
                                                :message="getError(errors, 'length')"
                                                :type="getType(errors, 'length', '')"
                                            >
                                                <b-input v-model="record.length"></b-input>
                                            </b-field>
                                        </div>
                                        <div class="column medium-4">
                                            <b-field label="Breedte"
                                                :message="getError(errors, 'width')"
                                                :type="getType(errors, 'width', '')"
                                            >
                                                <b-input v-model="record.width"></b-input>
                                            </b-field>
                                        </div>
                                        <div class="column medium-4">
                                            <b-field label="Hoogte"
                                                :message="getError(errors, 'height')"
                                                :type="getType(errors, 'height', '')"
                                            >
                                                <b-input v-model="record.height"></b-input>
                                            </b-field>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <b-field :label="'Prijs ('+formatPrice+')'"
                                :message="getError(errors, 'price')"
                                :type="getType(errors, 'price', '')"
                            >
                                <b-input v-model="record.price"></b-input>
                            </b-field>

                            <b-field :label="'Borg ('+formatDeposit+')'"
                                :message="getError(errors, 'deposit')"
                                :type="getType(errors, 'deposit', '')"
                            >
                                <b-input v-model="record.deposit"></b-input>
                            </b-field>

                            <b-field label="BTW percentage"
                                :message="getError(errors, 'btw')"
                                :type="getType(errors, 'btw', '')"
                            >
                                <b-input type="number" v-model.number="record.btw"></b-input>
                            </b-field>

                            <br>

                            <b-field>
                                <b-checkbox v-model="record.active" :disabled="record.status != 'free' && record.status != 'inactive'">
                                    Actief
                                </b-checkbox>
                                <b-tooltip label="De status kan enkel aangepast worden indien de box niet gereserveerd/verhuurd is." position="is-right" v-show="record.status != 'free' && record.status != 'inactive'" style="float:right;margin-left: 5px;">
                                    <b-icon icon="exclamation-circle" type="is-info" />
                                </b-tooltip>
                            </b-field>

                            <b-field>
                                <b-checkbox v-model="record.hide_online">
                                    Verberg box voor online verhuur
                                </b-checkbox>
                            </b-field>

                            <b-field label="Pad op plattegrond"
                                :message="getError(errors, 'path')"
                                :type="getType(errors, 'path', '')"
                                v-if="user && user.id == 1"
                            >
                                <b-input v-model="record.path"></b-input>
                            </b-field>
                        </b-tab-item>

                        <b-tab-item label="Klant(en)">
                            <b-tabs
                                class="organisation-tabs"
                                vertical
                                type="is-boxed"
                                v-model="customerTabIndex"
                            >
                                <b-tab-item label="Huidige klant">
                                    <div v-if="record.customer_id">
                                        <div class="row">
                                            <div class="column small-7">
                                                <h1 class="title">Klant gekoppeld</h1>
                                            </div>
                                            <div class="column small-5 text-right">
                                                <b-button v-if="canRemoveCustomer" type="is-danger is-light" @click="removeCustomer" :loading="loading">Klant ontkoppelen</b-button>
                                            </div>
                                        </div>

                                        <CRUDCustomer
                                            :id="record.customer_id"
                                            :getCustomer="record.customer"
                                            :showAlert="true"
                                            :canRemoveCustomer="false"
                                            :organisation="record?.organisation"
                                        />
                                    </div>
                                    <div v-else>
                                        <h1 class="title">Klant koppelen</h1>
                                        <p>Koppel een bestaande klant aan deze box of maak een nieuwe klant aan.</p>

                                        <br>
                                        <hr>
                                        <br>

                                        <h3>Bestaande klant zoeken</h3>
                                        <p>Zoek een bestaande klant om te koppelen aan deze box.</p>
                                        <br>

                                        <FindCustomer
                                            :organisation="record?.organisation"
                                            :showAllCustomers="true"
                                            :buttonOnly="true"
                                            @linkCustomer="linkCustomer"
                                        />

                                        <br>
                                        <hr>
                                        <br>

                                        <h3>Nieuwe klant aanmaken</h3>
                                        <p>Vul de gegevens in om een nieuwe klant aan te maken en te koppelen aan deze box.</p>
                                        <br>

                                        <CRUDCustomer
                                            :key="'new-customer-' + (record.customer_id || 'empty')"
                                            id="nieuw"
                                            type="edit"
                                            embedded_from="BoxRecord"
                                            :canRemoveCustomer="false"
                                            :organisation="record?.organisation"
                                            @linkCustomer="linkCustomer"
                                        />
                                    </div>
                                </b-tab-item>

                                <b-tab-item label="Volgende reservering" :disabled="!record.next_reserved && (!record.customer_id || !record.contract)">
                                    <div v-if="record.next_reserved">
                                        <div class="row">
                                            <div class="column small-7">
                                                <h1 class="title">Gereserveerd voor volgende klant</h1>
                                            </div>
                                            <div class="column small-5 text-right">
                                                <b-button type="is-danger is-light" @click="removeNextReservation" :loading="loading">Volgende reservering verwijderen</b-button>
                                            </div>
                                        </div>

                                        <CRUDCustomer
                                            :id="record.next_reserved"
                                            :getCustomer="record.next_customer"
                                            :showAlert="true"
                                            :canRemoveCustomer="false"
                                            :organisation="record?.organisation"
                                        />
                                    </div>

                                    <div v-else>
                                        <h1 class="title">Reserveren voor volgende klant</h1>
                                        <p>Reserveer deze box voor een volgende klant zonder contract aan te maken. Wanneer het huidige contract eindigt, wordt de box status 'gereserveerd' en gekoppeld aan de volgende klant.</p>

                                        <br>
                                        <hr>
                                        <br>

                                        <h3>Bestaande klant zoeken</h3>
                                        <p>Zoek een bestaande klant om te reserveren voor deze box.</p>
                                        <br>

                                        <FindCustomer
                                            :organisation="record?.organisation"
                                            :showAllCustomers="true"
                                            :buttonOnly="true"
                                            @linkCustomer="setNextReservation"
                                        />

                                        <br>
                                        <hr>
                                        <br>

                                        <h3>Nieuwe klant aanmaken</h3>
                                        <p>Vul de gegevens in om een nieuwe klant aan te maken en te reserveren voor deze box.</p>
                                        <br>

                                        <CRUDCustomer
                                            :key="'new-next-customer-' + (record.next_reserved || 'empty')"
                                            id="nieuw"
                                            type="edit"
                                            embedded_from="BoxRecord"
                                            :canRemoveCustomer="false"
                                            :organisation="record?.organisation"
                                            @linkCustomer="setNextReservation"
                                        />
                                    </div>
                                </b-tab-item>
                            </b-tabs>
                        </b-tab-item>

                        <b-tab-item label="Contract">
                            <template slot="header">Contract<span v-if="!record.contract && record.customer_id">&nbsp;<font-awesome-icon :icon="['fas', 'exclamation-triangle']"/></span></template>
                            <div v-if="!record.contract && record.customer_id">
                                <div class="callout warning">Geen contract actief voor deze box!</div>
                                <br>
                                <b-button type="is-dark" @click="addContract()" :disabled="!organisation || organisation.invited == 0">Contract aanmaken</b-button>
                            </div>
                            <div v-else-if="!record.contract && !record.customer_id">
                                <p>Geen contract gevonden.</p>
                                <b-button type="is-dark" @click="addContract()" :disabled="!organisation || organisation.invited == 0">Contract aanmaken</b-button>
                            </div>

                            <b-notification
                                type="is-warning"
                                aria-close-label="Close notification"
                                role="alert"
                                class="margintop10"
                                v-if="!organisation || organisation.invited == 0"
                            >
                                Er kan geen contract aangemaakt worden omdat de organisatie nog niet uitgenodigd is.
                            </b-notification>

                            <hr v-show="!record.contract">

                            <div>
                                <div class="row">
                                    <div class="column small-5">
                                        <h4 v-if="amountOfContracts > 0">{{ amountOfContracts == 1 ? 'Contract gekoppeld aan deze box' : 'Alle contracten' }}</h4>
                                    </div>
                                    <div class="column small-7 text-right">
                                        <b-button v-if="record.contract" type="is-dark" @click="addContract()" :disabled="!organisation || organisation.invited == 0">Contract aanmaken</b-button>
                                    </div>
                                </div>
                                <ContractsOverviewTable
                                    ref="ContractsOverviewTable"
                                    @giveAmountOfContracts="setAmountOfContracts"
                                    :allowSorting="false"
                                />
                            </div>
                        </b-tab-item>

                        <b-tab-item label="Facturen">
                            <b-tabs v-model="invoiceTabIndex">
                                <b-tab-item :label="`Actief contract${ totalActiveInvoices ? ' ('+totalActiveInvoices+')' : '' }`">
                                    <InvoicesTable
                                        type="box"
                                        :extraParams="[{ activecontract: true }]"
                                        :id="$route.params.id"
                                        @passTotal="passTotalActive"
                                    />
                                </b-tab-item>

                                <b-tab-item :label="`Inactief contract${ totalInactiveInvoices ? ' ('+totalInactiveInvoices+')' : '' }`">
                                    <InvoicesTable
                                        type="box"
                                        :extraParams="[{ activecontract: false }]"
                                        :id="$route.params.id"
                                        @passTotal="passTotalInactive"
                                    />
                                </b-tab-item>
                            </b-tabs>
                        </b-tab-item>

                        <b-tab-item label="Connect" v-if="user && user.role == 'pit' && user.organisation_connect && !user.deurwaarder">
                            <template slot="header">
                                Toegang&nbsp;
                                <b-icon v-if="connectLoaded" icon="key" size="is-small" :class="{
                                    'has-text-danger': hasValidAccess === false,
                                    'has-text-success': hasValidAccess === true,
                                    'has-text-grey': hasValidAccess === null
                                }" />
                                <b-icon v-else icon="spinner" size="is-small" class="fa-spin" />
                            </template>

                            <div class="row">
                                <div class="column small-7">
                                    <h1 class="title">Toegang</h1>
                                </div>
                                <div class="column small-5 text-right">
                                    <template v-if="!record.customer_id">
                                        <b-tooltip label="Geen klant gekoppeld om toegang aan te kunnen maken" position="is-left">
                                            <b-button disabled type="is-primary">Toegang aanmaken</b-button>
                                        </b-tooltip>
                                    </template>
                                    <template v-else>
                                        <b-button type="is-primary" tag="router-link" :to="`/panel/connect/nieuw?contract=${record.contract || ''}&customer=${record.customer_id}`">Toegang aanmaken</b-button>
                                    </template>
                                </div>
                            </div>

                            <ConnectTable
                                ref="ConnectTable"
                                type="box"
                                :id="$route.params.id"
                                @connectloaded="connectLoaded = true"
                                @open="setHasValidAccess"
                            />
                        </b-tab-item>

                        <b-tab-item label="Logs" v-if="user && user.role == 'pit'">
                            <h3>Logs</h3>

                            <LogsRecord
                                ref="LogsRecord"
                                :getFilters="{0: {name: record.number, query: { subject_type: 'App\\Box', subject_id: record.id }}}"
                            />
                        </b-tab-item>

                        <!-- Adding a new tab? Also update the tabIndex in the UserSettings.vue! -->
                    </b-tabs>
                </form>

                <slide-up-down :active="showFormFooter && !hideSaving" :duration="500">
                    <div class="row">
                        <div class="column">
                            <div class="formfooter" :key="formFooterKey">
                                <div class="column medium-6 small-12">
                                    <!-- <b-button type="is-info is-light" @click="showForceFreeModal = true" :disabled="record.status == 'free'" v-show="user.role == 'pit' || (!_.isNull(user.organisation) && user.is_admin)">Forceer status "Vrij"</b-button> -->
                                    <b-button type="is-warning is-light" v-if="showEscalation" :disabled="!record || !record.contract" @click="$refs['InvoiceEscalateModals'].toggleEscalateModal({esc_contract: _.has(record, 'contract') ? record.contract : null, customer: record.customer_id })">
                                        {{ escalationName == 'escalatie' ? 'Escaleren' : 'Deurwaarder' }}
                                    </b-button>
                                </div>
                                <div class="column medium-6 small-12 text-right">
                                    <b-button type="is-success" :loading="loading" @click="normalSave()">Opslaan</b-button>
                                    <b-button type="is-dark" :loading="loading" @click="saveAndQuit()">Opslaan en sluiten</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import CRUDCustomer from '@/vue/CRUDCustomer'
import FindCustomer from '@/vue/FindCustomer'
import LogsRecord from '@/vue/logs/LogsRecord'
import ContractsOverviewTable from '@/vue/contracts/ContractsOverviewTable'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import toastMixin from '@/mixins/toastMixins.js'
import escalationMixin from '@/mixins/escalationMixin.js'
import InvoicesTable from '@/vue/invoices/components/InvoicesTable'
import InvoiceEscalateModals from '@/vue/invoices/components/InvoiceEscalateModals'
import ConnectTable from '@/vue/connect/components/ConnectTable'

export default {
    name: 'BoxesRecord',

    components: {
        CRUDCustomer,
        FindCustomer,
        LogsRecord,
        ContractsOverviewTable,
        InvoicesTable,
        InvoiceEscalateModals,
        ConnectTable
    },

    mixins: [formvalidationMixin, toastMixin, escalationMixin],

    data () {
        return {
            tabIndex: this.$store.state.user?.settings?.open_box || 0,
            customerTabIndex: 0,
            invoiceTabIndex: 0,
            record: {},
            loading: false,
            errors: {},
            showFormFooter: true,
            amountOfContracts: 0,
            showForceFreeModal: false,
            formFooterKey: 0,

            totalActiveInvoices: null,
            totalInactiveInvoices: null,

            // Connect/access related
            connectLoaded: false,
            hasValidAccess: null
        }
    },

    computed: {
        // initialized () {
        //     return this.$store.state.initialized
        // },
        canRemoveCustomer(){
            return !!this.record.customer_id && _.isNull(this.record.contract)
        },
        formatPrice(){
            return this.record.price && parseInt(this.record.price) > 0 ? '€ '+Number.parseFloat(this.record.price).toFixed(2) : '€ '+Number.parseFloat(0).toFixed(2)
        },
        formatDeposit(){
            return this.record.deposit && parseInt(this.record.deposit) > 0 ? '€ '+Number.parseFloat(this.record.deposit).toFixed(2) : '€ '+Number.parseFloat(0).toFixed(2)
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },
        hideSaving() {
            return false
        },
        organisation() {
            if (this.user.role === 'pit') {
                return _.find(this.$store.state.organisations, ['id', this.record.organisation])
            }

            return this.user.organisations ? this.user.organisations[this.record.organisation] : null
        }
    },

    created () {
        this.fetchRecord()
    },

    mounted() {
        if(this.$refs['ContractsOverviewTable']){
            this.$refs['ContractsOverviewTable'].loadContractsFromBox(this.$route.params.id)
        }
    },

    methods: {
        fetchRecord(){
            console.log('[🔥] Fetch box', this.$route.params)
            this.loading = true

            axios.get('/api/boxes/'+this.$route.params.id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                response.data.active = Boolean(response.data.active)
                response.data.hide_online = Boolean(response.data.hide_online)

                Vue.set(this, 'record', response.data)

                if(this.user.role == 'pit'){
                    setTimeout(() => {
                        this.$refs['LogsRecord']?.load()
                        this.formFooterKey = this.formFooterKey + 1
                    }, 250)
                }
            }).catch((error) => {
                console.error('[❌] Error while fetching box:', error)
                // this.showError('Er is iets fout gegaan tijdens het ophalen van de box.')
            }).then(() => {
                this.loading = false
            })
        },

        linkCustomer(customer){
            this.updateCustomer(parseInt(customer.id))
            .then((response) => {
                Vue.set(this, 'record', response)
            }).catch((error) => {
                console.error('[❌] Error while adding customer!', error)
            })
        },

        removeCustomer(){
            this.updateCustomer('remove')
            .then((response) => {
                Vue.set(this, 'record', response)
            }).catch((error) => {
                console.error('[❌] Error while removing customer!', error)
            })
        },

        /**
         * Types: (ID) or 'remove'
         */
        updateCustomer(removeOrID){
            return new Promise((resolve, reject) => {
                if(_.isNull(this.record.contract) && (removeOrID != 'undefined')){
                    this.loading = true

                    axios.put('/api/box/'+this.record.id+'/update/customer', {'customer_id': (removeOrID == 'remove' ? null : removeOrID) }, {
                        headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                    }).then((response) => {
                        resolve(response.data)
                    }).catch((error) => {
                        reject(error)
                        alert('Daar gaat iets fout! Probeer het opnieuw.')
                    }).then(() => {
                        this.loading = false
                    })
                } else {
                    console.error('[❌] You can\'t remove a customer if a contract is active, or you didnt supply a removeOrID!')
                    reject('no_contract_or_removeOrID_supplied')
                }
            })
        },

        save(type) {
            this.loading = true
            this.errors = {}

            let sendData = {...this.record}
            if(typeof(sendData.customer) != 'undefined'){
                delete sendData.customer
            }

            return new Promise((resolve, reject) => {
                axios.put('/api/box/'+this.record.id+'/save', sendData, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    if(type == 'add_contract') {
                        resolve()
                        return
                    } else if(type != 'and_quit'){
                        response.data.active = Boolean(response.data.active)
                        response.data.hide_online = Boolean(response.data.hide_online)

                        Vue.set(this, 'record', response.data)
                    }

                    this.showMessage('Succesvol opgeslagen!')
                    resolve();
                }).catch((error) => {
                    console.error('[❌] Error while validating the box:', error)

                    // Show that decimals with dot is possible.
                    if(_.has(error, 'response.data.errors.size')) {
                        error.response.data.errors.size = [error.response.data.errors.size += ' Decimalen zijn mogelijk met een punt.']
                    }
                    if(_.has(error, 'response.data.errors.length')) {
                        error.response.data.errors.length = [error.response.data.errors.length += ' Decimalen zijn mogelijk met een punt.']
                    }
                    if(_.has(error, 'response.data.errors.width')) {
                        error.response.data.errors.width = [error.response.data.errors.width += ' Decimalen zijn mogelijk met een punt.']
                    }
                    if(_.has(error, 'response.data.errors.height')) {
                        error.response.data.errors.height = [error.response.data.errors.height += ' Decimalen zijn mogelijk met een punt.']
                    }


                    if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                        this.showError('Opslaan is niet mogelijk. Alleen een administrator heeft de bevoegdheid om deze gegevens te wijzigen.')
                    } else {
                        this.showError('Opslaan mislukt - Onvoldoende of onjuiste gegevens.')
                    }

                    this.errors = {...error.response.data.errors}

                    reject()
                }).then(() => {
                    this.loading = false
                })
            })
        },

        addContract(){
            if(_.has(this.user.organisation_settings, 'strictroles') && this.user.organisation_settings.strictroles == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                this.$router.push({name: 'ContractsRecord', params: {id: 'nieuw'}, query: {'box': this.record.id, 'customer': this.record.customer_id}})
                return
            }

            this.save('add_contract').then(() => {
                console.log('All data is valid, let\'s create the contract!')
                let queryObject = {
                    'box': this.record.id
                }
                if(this.record.customer_id){
                    queryObject.customer = this.record.customer_id
                }

                this.$router.push({name: 'ContractsRecord', params: {id: 'nieuw'}, query: queryObject})
            }).catch((error) => {
                console.error('[❌] Error while validating form before going to new contract!', error)
                this.tabIndex = 0
            })
        },

        normalSave(){
            this.save().then(() => {
                this.$refs['LogsRecord']?.load()
            })
        },

        saveAndQuit(){
            this.save('and_quit').then((response) => {
                console.log('All data is valid, let\'s go back to the overview!')

                this.$router.push({name: 'BoxesOverview'})
            }).catch((error) => {
                console.error('[❌] Error while validating form before going back to the overview!', error)
                this.tabIndex = 0
            })
        },

        tabChange(value){
            // If algemeen or admin tab
            if(value === 0){
                this.showFormFooter = true
            } else {
                this.showFormFooter = false
            }
        },

        setAmountOfContracts(number){
            this.amountOfContracts = number
        },

        passTotalActive(total){
            this.totalActiveInvoices = total
        },

        passTotalInactive(total){
            this.totalInactiveInvoices = total
        },

        forceFree() {
            this.loading = true

            axios.post('/api/boxes/'+this.record.id+'/forcefree', {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.showMessage('Box status is op "Vrij" geforceerd!')
                this.fetchRecord()
            }).catch((e) => {
                if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                    this.showError('Opslaan is niet mogelijk. Alleen een administrator heeft de bevoegdheid om deze gegevens te wijzigen.')
                } else {
                    this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                }
            }).then(() => {
                this.loading = false
                this.showForceFreeModal = false
            })
        },

        // Set the hasValidAccess variable, to show if the box is connected with an connect access
        setHasValidAccess(hasValidAccess){
            this.hasValidAccess = hasValidAccess
        },

        setNextReservation(customer){
            this.loading = true

            axios.put('/api/box/'+this.record.id+'/update/next_reserved', {
                'next_reserved': parseInt(customer.id)
            }, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                Vue.set(this, 'record', response.data)
                this.showMessage('Volgende reservering succesvol aangemaakt!')
            }).catch((error) => {
                console.error('[❌] Error while setting next reservation!', error)

                if (error.response?.data?.error === 'no-active-contract') {
                    this.showError('Er kan geen reservering aangemaakt worden zonder actief contract.')
                } else {
                    this.showError('Er is iets fout gegaan tijdens het aanmaken van de reservering.')
                }
            }).then(() => {
                this.loading = false
            })
        },

        removeNextReservation(){
            this.loading = true

            axios.put('/api/box/'+this.record.id+'/update/next_reserved', {
                'next_reserved': null
            }, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                Vue.set(this, 'record', response.data)
                this.showMessage('Volgende reservering succesvol verwijderd!')

                // Also fetch the record to refresh the data
                this.fetchRecord()
            }).catch((error) => {
                console.error('[❌] Error while removing next reservation!', error)
                this.showError('Er is iets fout gegaan tijdens het verwijderen van de reservering.')
            }).then(() => {
                this.loading = false
            })
        }
    }
}
</script>
